module.exports = __webpack_public_path__ + "media/images/dividend/ill-success-right-4ff925d3c8613b8c92c4f0bc038001ef.svg";